import { driver } from 'driver.js';
import { useTLang } from 'intl/intl';
import { useRef } from 'react';
import type { AdoptionSteps, DriverInstance } from './featureAdoption.model';

import 'driver.js/dist/driver.css';
import './styles.css';

export function featureAdoptionLib({
  delayToStartInMs = 1_000,
  allowClose = true,
}: Partial<ServiceConfig> = {}) {
  const driverRef = useRef<DriverInstance | null>(null);
  let timeoutId: NodeJS.Timeout;

  const _nextBtnText = useTLang({
    id: 'next',
  });
  const _confirmText = useTLang({
    id: 'closedPartnerStateDialog.confirmText',
  });

  const startAdoption = (steps: AdoptionSteps) => {
    if (!driverRef.current) {
      timeoutId = setTimeout(() => {
        driverRef.current = driver({
          showProgress: false,
          popoverClass: 'driverjs-theme',
          showButtons: ['next'],
          nextBtnText: _nextBtnText,
          doneBtnText: _confirmText,
          allowClose,
          steps,
          smoothScroll: true,
        });
        driverRef.current.drive();
      }, delayToStartInMs);
    }
  };

  const destroyAdoption = () => {
    if (driverRef.current) {
      clearInterval(timeoutId);
      driverRef.current.destroy();
      driverRef.current = null;
    }
  };
  return {
    startAdoption,
    destroyAdoption,
    tooltip: driverRef,
  };
}

export interface ServiceConfig {
  delayToStartInMs: number;
  allowClose: boolean;
}
